import { StyleSheet } from 'aphrodite'
import mergeObjects from 'utils/mergeObjects'

const styles = {
  pill: {
    display: 'flex',
    padding: 3,
    margin: 1,
    backgroundColor: 'rgb(0, 105, 180)',
    borderRadius: 2,
    color: '#fff',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    MsUserSelect: 'none',
    userSelect: 'none'
  },
  label: {
    fontSize: 11,
    outline: 0,
    wordWrap: 'break-word',
    fontWeight: 400
  },
  toggleable: {
    cursor: 'pointer'
  },
  toggle: {
    display: 'inline',
    marginLeft: 5,
    fontSize: 11,
    fontWeight: 600,
    width: 8
  },
  deselected: {
    color: '#acacac',
    background: '#ececec'
  }
}

const dark = {
  pill: {
    backgroundColor: '#4b4b4b',
    color: '#fff'
  },
  deselected: {
    color: '#525252',
    background: '#2c2b2b'
  }
}

const themes = {
  light: StyleSheet.create(styles),
  dark: StyleSheet.create(mergeObjects(styles, dark))
}

export default themes



// WEBPACK FOOTER //
// ./src/components/Common/PillContainer/Pill/styles.js